import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import ExtrasFieldset from 'book-calculator/containers/ExtrasFieldset';

const ExtrasStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.extras.heading" />}
        description={<FormattedMessage id="steps.extras.description" />}
    >
        <div className="paragraph paragraph--root">
            <ul className="list list--offset">
                <li>
                    <FormattedMessage id="steps.extras.list.item_1" />
                </li>
                <li>
                    <FormattedMessage id="steps.extras.list.item_2" />
                </li>
                <li>
                    <FormattedMessage id="steps.extras.list.item_3" />
                </li>
                <li>
                    <FormattedMessage id="steps.extras.list.item_4" />
                </li>
                <li>
                    <FormattedMessage id="steps.extras.list.item_5" />
                </li>
            </ul>
        </div>

        <div className="heading heading--h4 heading--grey800">
            <FormattedMessage id="steps.extras.subheading" />
        </div>

        <ExtrasFieldset />
    </Step>
);

ExtrasStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default ExtrasStep;
